import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";

import "./SmartCities/SmartCities.css";

const OurCompanies = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const [rtl, setRtl] = useState(localStorage.getItem("Language") == "rtl");
  const [fr, setFr] = useState(localStorage.getItem("Language") == "fr");

  useEffect(() => {
    var rtl = document.querySelector("body").getAttribute("class");
    if (rtl) {
      if (rtl.includes("rtl")) {
        setRtl(true);
      } else {
        setRtl(false);
      }
    }
  }, []);

  return (
    <>
      <div>
        <div class="wrapper" id="cover">
          <img
            src={require("../Assets/images/cover-companies-.jpg")}
            class="prx"
            style={{ height: "205px", width: "100%" }}
          />
          <h1>{rtl ? `شركاتنا` : fr ? "NOS ENTREPRISES" : `Our Companies`}</h1>
        </div>
      </div>

      <div id="bodycont" class="bg">
        <div class="pagewrap">
          <div class="wrapper grid5">
            <article class="fluid animated fadeInRight">
              <div class="col">
                <div class="left-nav">
                  <ul>
                    <li>
                      <strong>
                        {rtl ? `خدماتنا` : fr ? "NOS SERVICES" : `Our Services`}
                      </strong>
                    </li>

                    {/* <li>
                                            <strong></strong>

                                            <p class="mt05">
                                                <Link to="/services">MMH</Link>
                                            </p>
                                        </li> */}

                    <li>
                      <p class="mt05">
                        <Link to="/services">
                          {rtl
                            ? `أول عملة مشفرة
`
                            : fr
                            ? "LA PREMIÈRE CRYPTO-MONNAIE"
                            : `The First Cryptocurrency`}
                        </Link>
                      </p>
                    </li>

                    <li>
                      <p class="mt05">
                        <Link to="/services">
                          {rtl
                            ? `أفريقيا في عام 2023`
                            : fr
                            ? "L'AFRIQUE EN 2023"
                            : `Africa in 2023`}
                        </Link>
                      </p>
                    </li>
                    <li>
                      <p class="mt05">
                        <Link to="/services">
                          {rtl
                            ? ` الذهب والماس`
                            : fr
                            ? "OR ET DIAMANTS"
                            : `Gold & Diamonds`}
                        </Link>
                      </p>
                    </li>
                    <li>
                      <p class="mt05">
                        <Link to="/services">
                          {rtl
                            ? `هندسة النفط والغاز`
                            : fr
                            ? "INGÉNIERIE PÉTROLIÈRE ET GAZIÈRE"
                            : `Oil & Gas Engineering`}
                        </Link>
                      </p>
                    </li>
                    <li>
                      <p class="mt05">
                        <Link to="/services">
                          {rtl
                            ? ` المصانع والبنية التحتية`
                            : fr
                            ? "USINES ET INFRASTRUCTURES"
                            : `Plants & Infrastructure`}
                        </Link>
                      </p>
                    </li>
                    <li>
                      <p class="mt05">
                        <Link to="/services">
                          {rtl
                            ? ` مدن الطاقة الذكية`
                            : fr
                            ? "VILLES INTELLIGENTES ET ÉNERGÉTIQUES"
                            : `Smart Energy Cities`}
                        </Link>
                      </p>
                    </li>
                    <li>
                      <p class="mt05">
                        <Link to="/services">
                          {rtl
                            ? `رؤية 2030 للحج والعمرة`
                            : fr
                            ? "VISION 2030 POUR LE HAJJ ET L'OMRAH"
                            : `2030 Vision for Hajj & Umrah`}
                        </Link>
                      </p>
                    </li>
                    <li>
                      <p class="mt05">
                        <Link to="/services">
                          {rtl
                            ? `المؤسسة الخيرية`
                            : fr
                            ? "FONDATION DE CHARITÉ"
                            : `Charity Foundation`}
                        </Link>
                      </p>
                    </li>
                  </ul>
                </div>
              </div>
            </article>
            <article class="fluid three animated fadeInDown">
              <div class="col">
                {/* <h1>Our Companies</h1> */}

                <p>&nbsp;</p>
                <div class="right-box-prod-full">
                  <h1>
                    {rtl
                      ? ` مكة  والمدينة القابضة المحدودة`
                      : fr
                      ? "MMH"
                      : "MMH"}
                  </h1>
                  <div
                    style={{
                      display: "flex",
                      alignItems: "flex-start",
                    }}
                  >
                    <img
                      src={require("../Assets/mmh-company.png")}
                      class="imgleft rez"
                    />

                    <p>
                      {rtl
                        ? `باعتبارها واحدة من أقدم قصص النجاح وأكثرها شهرة ، تم تشكيل  مكة  والمدينة القابضة من قبل سيدي شهيد .
تبحث مكة و المدينة القابضة المحدودة
 عن فرص حيث سيساعد الاستثمار في برامج التنمية الاقتصادية في إعادة بناء البلدان وخلق فرص العمل وتحسين نوعية الحياة للجميع. وفي هذا الصدد، تركز " مكة  والمدينة القابضة المحدودة
" حاليا على العديد من البلدان في أفريقيا بهدف توفير استثمارات معززة من شركائها الاستراتيجيين في الشرق الأوسط وأوروبا وجنوب آسيا.
 باستخدام هيكل التمويل الذاتي المبتكر لإطلاق التطوير ، لا يدخل المستثمرون الصورة إلا بعد الانتهاء من مراحل البحث والتصميم الأولية بنجاح.
`
                        : fr
                        ? `Recherche des opportunités où l'investissement dans des
                        programmes de développement économique contribuera à la
                        reconstruction des pays, à la création d'emplois et à l'amélioration
                        de la qualité de vie pour tous. À cet égard, MMH se concentre
                        actuellement sur plusieurs pays d'Afrique, avec l'objectif de fournir
                        des investissements accrus de la part de ses partenaires
                        stratégiques du Moyen-Orient, d'Europe et d'Asie du Sud. Utilisant
                        une structure innovante d'autofinancement pour lancer le
                        développement, les investisseurs n'entrent en scène qu'une fois
                        les phases initiales de recherche et de conception achevées avec
                        succès.`
                        : `Seeks opportunities where investment
                                            in economic development programs
                                            will help rebuild countries, create
                                            jobs, and improve the quality of
                                            life for all. In this regard, MMH is
                                            currently focused on multiple
                                            countries in Africa with the
                                            objective of providing enhanced
                                            investments from its strategic
                                            partners in the Middle East, Europe
                                            and Southern Asia. Utilizing an
                                            innovative self-funding structure to
                                            launch development, investors enter
                                            the picture only after the initial
                                            research and design phases have been
                                            successfully completed.`}
                    </p>
                  </div>

                  <p>&nbsp;</p>
                </div>
                <div class="right-box-prod-full">
                  <h1>
                    {rtl
                      ? `جولد بار الدولية المحدودة `
                      : fr
                      ? "Gold Bar International LTD"
                      : `Gold Bar International LTD`}
                  </h1>
                  <div class="companies-content">
                    <img src="/goldBar.png" class="imgleft rez" />

                    <p>
                      {rtl
                        ? `نحن شركة خاصة تركز على المبيعات الفورية من مخزونات المنازل وكذلك عقود الإنتاج متعددة السنوات. بينما يقع مقرنا في لندن ، لدينا مكاتب مع موظفي دعم في خمس قارات. الخدمة المنفصلة والفردية ومستوى لا مثيل له من النزاهة هي السمات المميزة لعلامتنا التجارية.

لدينا مجموعة رائعة من السبائك الذهبية المتاحة للشراء هنا في شركة جولد بار الدولية المحدودة   . في مجموعتنا ، ستجد سبائك الذهب من شركات تكرير الذهب الرائدة ، بما في ذلك بامب سويس، أوميكور وميتالور
`
                        : fr
                        ? `Nous sommes une société privée qui se concentre sur les
                        ventes ponctuelles à partir des inventaires ainsi que sur les
                        contrats de production pluriannuels. Nous sommes basés à
                        Londres, mais nous avons des bureaux et du personnel de
                        soutien sur les cinq continents. Notre marque se caractérise
                        par un service discret et personnalisé, ainsi que par un niveau
                        d'intégrité inégalé. Nous disposons d'une gamme
                        exceptionnelle de lingots d'or disponibles à l'achat chez la
                        société Gold Bar International Ltd. Dans notre collection,
                        vous trouverez des lingots d'or provenant des principaux
                        raffineurs d'or, notamment PAMP Suisse, Umicore et
                        Métalor.`
                        : `We are a private company that
                                            focuses on spot sales from house
                                            inventories as well as multi-year
                                            production contracts. While we are
                                            based in London, we have offices
                                            with support staff on five
                                            continents. Discrete, one-on-one
                                            service and an unmatched level of
                                            integrity are the hallmarks of our
                                            brand. We have an outstanding range
                                            of golden bars available to purchase
                                            here at Gold Bar International Ltd
                                            Company. In our collection, you will
                                            find gold bars from leading gold
                                            refiners, including PAMP Suisse,
                                            Umicore and Metalor.`}
                    </p>
                  </div>

                  <p>&nbsp;</p>

                  <a href="#">
                    <p class="button" id="Link-btn">
                      {rtl ? `إقرأ المزيد` : fr ? "Lire la suite" : `Read More`}
                    </p>
                  </a>
                </div>

                <div class="right-box-prod-full">
                  <h1>
                    {rtl
                      ? `MMH & ABS المجموعة الهندسية`
                      : fr
                      ? "Groupe MMH & ABS Engineering"
                      : `MMH & ABS Engineering Group`}
                  </h1>
                  <div class="companies-content">
                    <img src="/mmh-logo.png" class="imgleft rez" />

                    <p>
                      {rtl
                        ? `تستخدم مجموعة MMH & ABS المجموعة الهندسية
 الأموال التي تم جمعها من المستثمرين وتسييل الموارد الطبيعية ، وتجعل التحول من "الإمكانات" إلى "الواقع" ممكنا. يحدث هذا التحول عندما يتحول الفحم الوفير في الأرض ، على سبيل المثال ، إلى وقود يومي يقود السيارات والشاحنات والقوارب والطائرات التي تخلق فرص عمل ومستوى معيشي محسنا لجميع الأفارقة.


 تقوم المجموعة الهندسية  بتصميم وبناء وتشغيل البنية التحتية للطاقة للمساعدة في نمو الدول.
`
                        : fr
                        ? `Le groupe MMH & ABS Engineering utilise les fonds collectés auprès
                        des investisseurs et la monétisation des ressources naturelles, et rend
                        possible la transformation du "potentiel" en "réalité". Cette
                        transformation a lieu lorsque, par exemple, le charbon abondant dans
                        le sol est transformé en carburants quotidiens qui alimentent les
                        voitures, les camions, les bateaux et les avions qui créent des emplois
                        et améliorent le niveau de vie de tous les Africains. MMH & ABS
                        conçoit, construit et exploite des infrastructures énergétiques qui
                        contribuent au développement des nations.`
                        : `The MMH & ABS Engineering Group
                                            utilizes the funds that have been
                                            raised from investors and the
                                            monetization of natural resources,
                                            and makes feasible the
                                            transformation from “potential” to
                                            “reality”. This transformation takes
                                            place when, for example, the
                                            abundant coal in the ground is
                                            transformed into everyday fuels that
                                            drive the cars, trucks, boats and
                                            planes that create jobs and an
                                            improved standard of living for all
                                            Africans. MMH & ABS designs, builds,
                                            and operates energy infrastructures
                                            to help grow nations.`}
                    </p>

                    <p>&nbsp;</p>
                  </div>
                  <a href="#">
                    <p class="button" id="Link-btn">
                      {rtl ? `إقرأ المزيد` : fr ? "Lire la suite" : "Read More"}
                    </p>
                  </a>
                </div>

                <div class="right-box-prod-full">
                  <h1>
                    {rtl
                      ? `بنك الاستثمار الإسلامي`
                      : fr
                      ? "Banque Islamique d'Investissement"
                      : `The Islamic Investment Bank`}
                  </h1>
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                    }}
                    class="companies-content"
                  >
                    <img
                      src={require("../Assets/images/bank-image.png")}
                      class="imgleft rez"
                    />

                    <p>
                      {rtl
                        ? `أول بنك استثماري إسلامي دولي هو أساس رؤية سيدي. إنه المحرك الذي يقود كل شيء آخر لأنه يوفر التمويل لتغذية التنمية الاقتصادية. وسيركز البنك على توظيف الأموال من المستثمرين في المناطق المستهدفة الرئيسية، وتحديدا الشرق الأوسط وأوروبا وآسيا. وسيكون لدى البنك مكاتب تداول "ثروات" أفريقيا بما في ذلك الذهب والفضة والبلاتين والماس وعدد كبير من المعادن للدول الأكثر تركيزا على التكنولوجيا. 

وستولد هذه الموارد الأموال التي يجب أن تعود إلى القارة لتحقيق الهدف الاجتماعي والتجاري البالغ الأهمية لأفريقيا.
`
                        : fr
                        ? `La première banque islamique internationale d'investissement
                        est le fondement de la vision de Sidi. Elle est le moteur de tout le
                        reste, car elle fournit les fonds nécessaires au développement
                        économique. La banque se concentrera sur le recrutement de
                        fonds auprès d'investisseurs dans des principales régions visées,
                        en particulier le Moyen-Orient, l'Europe et l'Asie. La Banque
                        disposera de comptoirs commerciaux pour les "richesses" de
                        l'Afrique, notamment l'or, l'argent, le platine, les diamants et
                        une pléthore de minerais pour les pays les plus axés sur la
                        technologie. Ces ressources généreront les fonds qui doivent
                        revenir sur le continent pour atteindre l'objectif social et
                        commercial si important pour l'Afrique.`
                        : `The first international islamic
                                            investment Bank is the foundation of
                                            Sidi’s vision. It is the engine that
                                            drives everything else as it
                                            provides the funding to fuel
                                            economic development. The Bank will
                                            focus on recruiting funds from
                                            investors in key target areas,
                                            specifically the Middle East, Europe
                                            and Asia. The Bank will have trading
                                            desks for the “riches” of Africa
                                            including gold, silver, platinum,
                                            diamonds and a plethora of minerals
                                            for the more technology-focused
                                            nations. These resources will
                                            generate the fundsthat must come
                                            back to the Continent to achieve the
                                            social and commercial objective so
                                            important to Africa.`}
                    </p>
                  </div>

                  <p>&nbsp;</p>

                  <a href="#">
                    <p class="button" id="Link-btn">
                      {rtl ? `إقرأ المزيد` : fr ? "Lire la suite" : `Read More`}
                    </p>
                  </a>
                </div>
                {/* <div class="right-box-prod-full">
                                    <h1>King Fish Commodity Group</h1>

                                    <img
                                        src={require("../Assets/images/commodity.png")}
                                        class="imgleft rez"
                                    />

                                    <p>
                                        In order to better meet the needs of our
                                        government, commercial and individual
                                        clients, The Islamic Investment Bank
                                        will offer trading desk services for
                                        precious metals, gemstones, and other
                                        natural resources as well as foreign
                                        currencies.
                                    </p>

                                    <p>&nbsp;</p>

                                    <Link to="/commodity-desk">
                                        <p class="button">Read More</p>
                                    </Link>
                                </div> */}
                <div class="right-box-prod-full">
                  <h1>
                    {rtl
                      ? `البذور العالمية`
                      : fr
                      ? "Global Seeds"
                      : `Global Seeds`}
                  </h1>
                  <img
                    src={require("../Assets/images/global-seeds.jpg")}
                    class="imgleft rez imgrtl"
                  />
                  <p></p>
                  <p>&nbsp;</p>
                  <Link to="#">
                    <p class="button">
                      {" "}
                      {rtl ? `إقرأ المزيد` : fr ? "Lire la suite" : `Read More`}
                    </p>
                  </Link>
                </div>
                <div class="right-box-prod-full">
                  <h1>
                    {rtl
                      ? " زينوكس  للتكنولوجيا"
                      : fr
                      ? "Zeno X Tech"
                      : `Zeno X Tech`}
                  </h1>
                  <img
                    src={require("../Assets/images/zeno.jpg")}
                    class="imgleft rez imgrtl"
                  />
                  <p></p>
                  <p>&nbsp;</p>
                  <Link to="#">
                    <p class="button">
                      {" "}
                      {rtl ? `إقرأ المزيد` : fr ? "Lire la suite" : `Read More`}
                    </p>
                  </Link>
                </div>
                <p>&nbsp;</p>

                <div class="addthis_native_toolbox"></div>
              </div>
            </article>
          </div>
        </div>
      </div>
    </>
  );
};

export default OurCompanies;
